import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FISP_TV_ADMIN_HOME_PATH, FISP_TV_ADMIN_MENU, FISP_TV_HOME_PATH } from "../config";
import { logoutFispTvAdmin } from "../session";
import fispLogo from "../assets/logo-iniciales-oscuro.png";

export default function AdminNavbar({ showLinks = false, showLogout = false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isCompactNav, setIsCompactNav] = useState(() => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth <= 940;
    });

    useEffect(() => {
        if (typeof window === "undefined") {
            return undefined;
        }

        const handleResize = () => {
            setIsCompactNav(window.innerWidth <= 940);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = () => {
        logoutFispTvAdmin();
        navigate("/fisp-tv", { replace: true });
    };

    const brandTarget = isCompactNav ? FISP_TV_ADMIN_HOME_PATH : FISP_TV_HOME_PATH;

    return (
        <header className={`tv-admin-navbar ${showLinks ? "has-links" : ""}${isCompactNav ? " is-compact" : ""}`}>
            <div className="tv-admin-shell tv-admin-navbar-inner">
                <Link
                    to={brandTarget}
                    className="tv-admin-brand"
                    aria-label={isCompactNav ? "Ir al menu principal del admin" : "Ir al home de FISP TV"}
                >
                    <img src={fispLogo} alt="FISP" />
                    <span>ADMIN</span>
                </Link>

                {!isCompactNav && (showLinks || showLogout) ? (
                    <div className="tv-admin-navbar-links-wrap">
                        {showLinks ? (
                            <nav className="tv-admin-navbar-links" aria-label="Secciones del admin">
                                {FISP_TV_ADMIN_MENU.map((item) => (
                                    <Link
                                        key={item.id}
                                        to={item.to}
                                        className={
                                            location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)
                                                ? "is-active"
                                                : ""
                                        }
                                    >
                                        {item.label}
                                    </Link>
                                ))}
                            </nav>
                        ) : null}

                        <button type="button" className="tv-admin-logout" onClick={handleLogout}>
                            Salir
                        </button>
                    </div>
                ) : null}
            </div>
        </header>
    );
}
